import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions({
            getExchangeRate: "requestService/getExchangeRate",
        }),
        formatAmount(amount, showDecimals = true) {
            return amount.toLocaleString("de-DE", {
              minimumFractionDigits: showDecimals ? 2 : 0,
              maximumFractionDigits: showDecimals ? 2 : 0,
            });
          },
        async mapExchangeRate(documents) {
            const coins = [
              ...new Set(
                documents
                  .filter((item) => item.coin && item.coin !== "CLP")
                  .map((item) => item.coin)
              ),
            ];
            let exchangeRates = [];
            const promises = coins.map(async (item) => {
              return this.getExchangeRate({ to_currency: item });
            });
            exchangeRates = await Promise.all(promises);
            const mapDocuments = documents.map((item) => {
              if (item.coin && item.coin !== "CLP") {
                const exchange = exchangeRates.find(
                  (exchange) => exchange.to_currency == item.coin
                );

                //Verificar si el price es string
                let price = typeof item.price == "string" ? Number(item.price.replaceAll(".", "").replaceAll(",", ".")) : item.price
                return {
                  ...item,
                  coin: item.coin ? item.coin : "CLP",
                  unit_amount: this.formatAmount(
                    item.price,
                    item.coin && item.coin !== "CLP"
                  ),
                  amount: exchange ? this.formatAmount(price * exchange.rate, false) : this.formatAmount(price, false),
                  exchange_rate: `1 ${item.coin} ⟺ ${exchange?.rate
                    ?.toString()
                    ?.replaceAll(".", ",")} CLP` || "---",
                };
              } else {
                return {
                  ...item,
                  coin: "CLP",
                  unit_amount: item.price ? this.formatAmount(item.price, false) : null,
                  amount: item.price ? this.formatAmount(item.price, false) : null,
                  exchange_rate: "---",
                };
              }
            });
            return mapDocuments;
          },
    }
}